export default __webpack_public_path__ + "static/media/CelularComMaoMobileExchange.0c463079.png";